import script from "./ModalProfit.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalProfit.vue?vue&type=script&setup=true&lang=js"

import "./ModalProfit.vue?vue&type=style&index=0&id=0a1ae13e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a1ae13e"]])

export default __exports__